import { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

import { scrollPositionContext } from '@context/Contexts';
import { ScrollPositionPageTypeEnum } from '@typing/Enums';

export default function useScrollPosition(type: ScrollPositionPageTypeEnum, setCondition = true): void {
  const { scrollPositionState, scrollToSavedPosition, setCurrentType } = useContext(scrollPositionContext);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const timeout: NodeJS.Timeout | null = null;
    setCurrentType(type);

    if (scrollPositionState.currentRef && scrollPositionState.currentType === type && setCondition) {
      const searchParams = new URLSearchParams(location.search);
      const preventScroll = searchParams.get('ps');
      if (preventScroll) {
        searchParams.delete('ps');
        history.replace({
          search: searchParams.toString()
        });
        return;
      }

      setTimeout(scrollToSavedPosition, 50);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCondition, scrollPositionState.currentRef, scrollPositionState.currentType]);

  // when unmounting, remove the current page
  useEffect(
    () => () => {
      setCurrentType(null);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
